import React from 'react';

import { TrackingStatus } from '../fields';

const ManualFulfillmentDisplayContent = () => {
  return <TrackingStatus />;
};

export default ManualFulfillmentDisplayContent;
